<div class="flex w-full profile--user-row">
  <app-user-common-info
    [showCopyFn]="true"
    [user]="user()"
  ></app-user-common-info>
</div>
<div class="divider horizontal w-full"></div>
<div [class.hide]="hidePrimaryData()" class="profile--stats">
  @for (stat of stats(); track stat.label) {
  <app-card [color]="stat.color" [coloredValue]="true">
    <svg-icon
      card-icon
      class="s-20 flex items-center justify-center"
      [src]="stat.icon"
    ></svg-icon>
    <span
      card-value
      [countUp]="stat.value"
      [reanimateOnClick]="false"
      [options]="stat.noFormat ? countUpOptionsNoFormat : countUpOptionsFormat"
    ></span>
    <span card-label>{{ stat.label }}</span>
  </app-card>
  }
</div>
<div class="divider horizontal w-full"></div>
<div [class.hide]="hidePrimaryData()" class="profile--trade-url flex gap-8 items-center w-full">
  <div class="form-field form-field--input-icon w-full">
    <label>Steam Trade URL </label>
    <div class="input-container w-full flex items-center">
      <svg-icon class="rounded-full s-16" [src]="'assets/icons/ui/steam.svg'" />
      <input
        [disabled]="true"
        [value]="user().tradelink || 'No Trade Link'"
        type="text"
      />
    </div>
  </div>
  <button
    type="button"
    (click)="copyTradeURL()"
    class="profile--trade-url__button"
    [disabled]="!user().tradelink"
  >
    Copy
  </button>
</div>
<div class="divider horizontal w-full"></div>
<div [class.hide]="hidePrimaryData()" class="profile--forms">
  <form [formGroup]="banForm" (ngSubmit)="submitBan()" #banFormRef="ngForm">
    <div class="profile--forms__info">
      <div class="profile--form-title">
        <p>Ban</p>
        @if (user().ban_by && user().ban_time !== 0) {
        <div animate.enter="animate-fade-in" animate.leave="animate-fade-out" class="profile--form-badge red">
          Ban by SteamID: {{ user().ban_by }}
        </div>
        }
      </div>
      <div
        class="profile--form-badge"
        [class.red]="user().ban_time !== 0"
        [class.green]="user().ban_time === 0"
      >
        {{ user().ban_time === 0 ? `User ${user().name} is not banned` : `User ${user().name} is banned`}}
        @if (user().ban_by && user().ban_time !== 0) {
        <button
          type="button"
          class="profile--form-tooltip"
          [ngpTooltipTrigger]="tooltipBanDetails"
          [ngpTooltipTriggerHideDelay]="0"    
          animate.enter="animate-fade-in"
        >
          <svg-icon src="assets/icons/shared/info.svg"></svg-icon>
        </button>
        <ng-template #tooltipBanDetails>
          <div ngpTooltip class="tooltip flex flex-col">
            <div>
              Time:
              <span style="text-transform: lowercase">
                {{ `${user().ban_time === -1 ? 'permanent' : `until ${(user().ban_time * 1000 | date : "medium")}`}` }}
              </span>
            </div>
            <div>
              Reason:
              <span style="text-transform: lowercase">
                {{ user().ban_reason }}
              </span>
            </div>
          </div>
        </ng-template>
        }
      </div>
    </div>
    <app-form-field
      [label]="'Time (in minutes/-1 for permanent)'"
      [formControl]="banTime"
      [errorType]="'outline'"
      [id]="'banTime'"
      type="number"
      [submitting]="false"
      [placeholder]="'Enter Duration...'"
      [disabled]="user().ban_time !== 0"
      [error]="
        !banTime.valid && banFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <app-form-field
      [label]="'Reason'"
      [formControl]="banReason"
      [errorType]="'outline'"
      [id]="'banReason'"
      [submitting]="false"
      [placeholder]="'Enter Reason...'"
      [disabled]="user().ban_time !== 0"
      [error]="
        !banReason.valid && banFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <button
      class="profile--form-button"
      type="submit"
      [class.red]="user().ban_time !== 0"
      [class.green]="user().ban_time === 0"
    >
      {{ user().ban_time === 0 ? "Ban" : "Unban" }}
      {{ user().name }}
    </button>
  </form>
  <div class="divider horizontal w-full"></div>
  <form [formGroup]="muteForm" (ngSubmit)="submitMute()" #muteFormRef="ngForm">
    <div class="profile--forms__info">
      <div class="profile--form-title">
        <p>Mute</p>
        @if (user().mute_by && user().mute_time !== 0) {
        <div animate.enter="animate-fade-in" animate.leave="animate-fade-out" class="profile--form-badge red">
          Muted by SteamID: {{ user().mute_by }}
        </div>
        }
      </div>
      <div
        class="profile--form-badge"
        [class.red]="user().mute_time !== 0"
        [class.green]="user().mute_time === 0"
      >
        {{ user().mute_time === 0 ? `User ${user().name} is not muted` : `User ${user().name} is muted`}}
        @if (user().mute_by && user().mute_time !== 0) {
        <button
          type="button"
          class="profile--form-tooltip"
          [ngpTooltipTrigger]="tooltipMuteDetails"
          [ngpTooltipTriggerHideDelay]="0"
          animate.enter="animate-fade-in"
        >
          <svg-icon src="assets/icons/shared/info.svg"></svg-icon>
        </button>
        <ng-template #tooltipMuteDetails>
          <div ngpTooltip class="tooltip flex flex-col">
            <div>
              Time:
              <span style="text-transform: lowercase">
                {{ `${user().mute_time === -1 ? 'permanent' : `until ${(user().mute_time * 1000 | date : "medium")}`}` }}
              </span>
            </div>
            <div>
              Reason:
              <span style="text-transform: lowercase">
                {{ user().mute_reason }}
              </span>
            </div>
          </div>
        </ng-template>
        }
      </div>
    </div>
    <app-form-field
      [label]="'Time (in minutes/-1 for permanent)'"
      [formControl]="muteTime"
      [errorType]="'outline'"
      [id]="'muteTime'"
      type="number"
      [submitting]="false"
      [placeholder]="'Enter Duration...'"
      [disabled]="user().mute_time !== 0"
      [error]="
        !muteTime.valid && muteFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <app-form-field
      [label]="'Reason'"
      [formControl]="muteReason"
      [errorType]="'outline'"
      [id]="'muteReason'"
      [submitting]="false"
      [placeholder]="'Enter Reason...'"
      [disabled]="user().mute_time !== 0"
      [error]="
        !muteReason.valid && muteFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <button
      class="profile--form-button"
      type="submit"
      [class.red]="user().mute_time !== 0"
      [class.green]="user().mute_time === 0"
    >
      {{ user().mute_time === 0 ? "Mute" : "Unmute" }}
      {{ user().name }}
    </button>
  </form>
  <div class="divider horizontal w-full"></div>
  <form [formGroup]="ticketBanForm" (ngSubmit)="submitTicketBan()">
    <div class="profile--forms__info">
      <div class="profile--form-title">
        <p>Ticket Ban</p>
      </div>
      <div
        class="profile--form-badge"
        [class.red]="user().ticket_ban !== 0"
        [class.green]="user().ticket_ban === 0"
      >
        {{ user().ticket_ban === 0 ? `User ${user().name} is not ticket banned` : `User ${user().name} is ticket banned`}}
      </div>
    </div>
    <app-form-field
      [label]="'Time (in minutes/-1 for permanent) (Not Editable)'"
      [errorType]="'outline'"
      [id]="'ticketBanTime'"
      [placeholder]="'Enter Duration...'"
      [disabled]="true"
      [value]="'-1'"
    />
    <app-form-field
      [label]="'Reason (Not Editable)'"
      [errorType]="'outline'"
      [id]="'ticketBanReason'"
      [placeholder]="'Enter Reason...'"
      [disabled]="true"
      [value]="'-'"
    />
    <button
      class="profile--form-button"
      type="submit"
      [class.red]="user().ticket_ban !== 0"
      [class.green]="user().ticket_ban === 0"
      style="margin-top: auto"
    >
      {{ user().ticket_ban === 0 ? "Ticket Ban" : "Ticket Unban" }}
      {{ user().name }}
    </button>
  </form>
</div>
